module.exports = __webpack_public_path__ + "static/media/15-bnner.db89bf0f.mp3";